// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__XOzQ8","white":"Button_white__nEiyJ","red":"Button_red__DFj1z","black":"Button_black__thG8R"};